module.exports = __webpack_public_path__ + "static/07-918d37957f41e6c34acb787939eb5c1b.png";